<template>
  <div class="mod-show-cards">
    <ul 
      v-if="list.length" 
      class="cards-box"
    >
      <li 
        v-for="(item, index) in list"
        :key="index"
        class="item-card"
      >
        <template v-for="(heads, type) in types">
          <div 
            v-if="type === 'title'" 
            :key="type"
            class="title-box"
          >
            <div 
              v-for="head in heads"
              :key="head.key"
              class="title-card"
            >
              <span class="title-card-text">
                {{ item[head.key] }}
                <span 
                  v-if="item[head.key] && item[head.key].length > 13" 
                  class="title-tip"
                >
                  {{ item[head.key] }}
                </span>
              </span>
              <i 
                v-if="isEdit"
                class="icon-edit" 
                @click="doEdit(item)" 
              />
            </div>
          </div>
          <div 
            v-else
            :key="type"
            class="label-box"
          >
            <template v-for="head in heads">
              <div
                v-if="shouldShowHead(head, item)"
                :key="head.key"
                class="item-label"
              >
                <label>{{ head.name }}：</label>
                <el-tooltip
                  v-if="head.tooltip && item[head.key]"
                  :content="item[head.key]"
                  placement="top"
                  effect="dark"
                >
                  <span class="item-label-text is-ellipsis">{{ item[head.key] }}</span>
                </el-tooltip>
                <span v-else>{{ item[head.key] }}</span>
                <div
                  v-if="head.appendActions && head.appendActions.length"
                  class="item-label-actions"
                >
                  <el-button
                    v-for="btn in head.appendActions"
                    :key="btn.key"
                    type="text"
                    :icon="btn.icon"
                    :title="btn.title"
                    :aria-label="btn.title"
                    @click.stop="$emit('action', item, head, btn)"
                  />
                </div>
              </div>
            </template>
          </div>
        </template>
      </li>
    </ul>
    <div 
      v-else-if="!loading"
      class="no-data-box"
    >
      <p>{{ noDataText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      default: false,
    },
    listData: {
      default: () => {
        return {};
      },
    },
    isEdit: {
      default: false,
    },
    noDataText: {
      default: '暂无数据',
    },
  },
  computed: {
    types() {
      let types = {};
      const headData = this.listData.head || [];
      if (headData.length) {
        headData.forEach((item) => {
          let type = item.type || 'label';
          if (types[type] && type !== 'title') {
            types[type].push(item);
          } else {
            types[type] = [item];
          }
        });
      }
      return types;
    },
    list() {
      return this.listData.list || [];
    },
  },
  methods: {
    shouldShowHead(head, item) {
      return !head.hideWhenEmpty || !!item[head.key];
    },
    doEdit(item) {
      this.$emit('edit', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.mod-show-cards {
  width: 100%;
  .cards-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .item-card {
      width: 312px;
      padding-bottom: 10px;
      margin: 6px;
      box-shadow: 0px 3px 10px -2px rgba(0, 0, 0, 0.03);
      border-radius: 4px;
      border: 1px solid #e0e0e0;
      &:hover {
        box-shadow: 0px 5px 17px -2px rgba(0, 0, 0, 0.2);
      }
      .title-box {
        .title-card {
          position: relative;
          display: flex;
          align-items: center;
          height: 47px;
          padding: 0 20px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          .title-card-text {
            flex-grow: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover {
              .title-tip {
                display: block;
              }
            }
            .title-tip {
              display: none;
              position: absolute;
              top: 37px;
              left: 20px;
              right: 3px;
              padding: 14px 10px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #fff;
              line-height: 20px;
              background: rgba(0, 0, 0, 0.78);
              box-shadow: 0px 8px 14px 0px rgba(0, 0, 0, 0.2);
              border-radius: 4px;
              white-space: normal;
            }
          }
          .icon-edit {
            flex-shrink: 0;
            display: inline-block;
            width: 20px;
            height: 20px;
            background-image: url('./images/icon_edit.svg');
            background-size: 20px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
      .label-box {
        .item-label {
          display: flex;
          height: 34px;
          line-height: 34px;
          padding: 0 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          label {
            flex-shrink: 0;
            white-space: nowrap;
          }
          .item-label-text {
            flex: 1;
            min-width: 0;
          }
          .is-ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .item-label-actions {
            display: flex;
            flex-shrink: 0;
            align-items: center;
            margin-left: 8px;
            .el-button {
              padding: 0;
              font-size: 14px;
            }
            .el-button + .el-button {
              margin-left: 8px;
            }
          }
          &:nth-child(2n + 1) {
            background: rgba(249, 249, 249, 1);
            box-shadow: 0px 3px 10px -2px rgba(0, 0, 0, 0.03);
          }
        }
      }
    }
  }
  .no-data-box {
    padding-top: 435px;
    background-image: url('./images/icon_no_data.png');
    background-size: 240px;
    background-repeat: no-repeat;
    background-position: center 171px;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #c0c4cc;
  }
}
</style>
